const menuRouter = [
    /**
     * 物资管理
     **/
    {
        path: '/wzgl/type',
        meta: { title: '类型管理' },
        component: () => import('@/views/page/wzgl/type'),
        used: true,
    },
    {
        path: '/wzgl/unit',
        meta: { title: '单位管理' },
        component: () => import('@/views/page/wzgl/unit'),
        used: true,
    },
    {
        path: '/wzgl/wzgl',
        meta: { title: '物资管理' },
        component: () => import('@/views/page/wzgl/wzgl'),
        used: true,
    },
    {
        path: '/wzgl/dlgl',
        meta: { title: '呆料管理' },
        component: () => import('@/views/page/wzgl/dlgl'),
        used: true,
    },
    {
        path: '/wzgl/warnning',
        meta: { title: '预警管理' },
        component: () => import('@/views/page/wzgl/warnning'),
        used: true,
    },
]

export default menuRouter
